(() => {
  const visible = element => Boolean(element?.getClientRects().length);

  const updateBanner = () => {
    const container = document.querySelector('#shopify-pc__banner .shopify-pc__banner__btns');
    if (!container) return;

    const customize = container.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!customize) return;

    customize.hidden = true;
    customize.tabIndex = -1;
    customize.setAttribute('aria-hidden', 'true');
  };

  updateBanner();
  new MutationObserver(updateBanner).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;

    const banner = document.querySelector('#shopify-pc__banner');
    if (!visible(banner) || visible(document.querySelector('#shopify-pc__prefs__dialog'))) return;
    const before = document.activeElement;

    setTimeout(() => {
      if (!event.defaultPrevented || !visible(banner) || visible(document.querySelector('#shopify-pc__prefs__dialog'))) return;

      const active = document.activeElement;
      const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
      const decline = banner.querySelector('#shopify-pc__banner__btn-decline');

      if (!banner.contains(active)) {
        (event.shiftKey ? decline : accept)?.focus();
      } else if (active === before && active === accept && !event.shiftKey) {
        decline?.focus();
      } else if (active === before && active === decline && event.shiftKey) {
        accept?.focus();
      }
    }, 0);
  }, true);
})();
